import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import View from "./RefundView";
import {cxOrderRefundApproval, cxOrderRefundData} from "../../../../services/redux/brandActivtion/meetings/action";
import {documentUploadUrlPublic} from "../../../../services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    orderRefundData: state.baMeetingReducer.orderRefundData,
    orderRefundActionData: state.baMeetingReducer.orderRefundActionData,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            cxOrderRefundData,
            cxOrderRefundApproval,
            documentUploadUrlPublic
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(View);
